import {Component, OnInit} from '@angular/core'
import {NbMenuService, NbSidebarService} from '@nebular/theme'
import {takeWhile} from 'rxjs/operators'
import {AuthService} from '../../auth.service'

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  private alive: boolean = true
  selectedItem: string
  userpro: boolean = false
  items = [
    {
      title: 'Home',
      link: '/home',
      icon: 'fa fa-home'
    },
    {
      title: 'Trade Data',
      link: '/tradedata',
      icon: 'fa fa-line-chart'
    },
    {
      title: 'Lithium Prices',
      link: '/liprices',
      icon: 'fa fa-usd'
    },
    {
      title: 'Li-Stats Reports',
      link: '/listats',
      icon: 'fa fa-file-text'
    }
  ]
  itemsfree = [
    {
      title: 'Home',
      link: '/home',
      icon: 'fa fa-home'
    },
    {
      title: 'Trade Data',
      link: '/tradedata',
      icon: 'fa fa-line-chart'
    }
  ]

  constructor(
    private menuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private auth: AuthService
  ) {
    auth.user$.subscribe(user => {
      if (user.userType === 'pro') {
        this.userpro = true
      } else {
        this.userpro = false
      }
    })
  }
  getSelectedItem() {
    console.log('entro')
    this.menuService
      .getSelectedItem('menu')
      .pipe(takeWhile(() => this.alive))
      .subscribe(menuBag => {
        this.selectedItem = menuBag.item.title
      })
  }
  closeFilters() {
    this.sidebarService.collapse('right')
  }

  ngOnInit() {}
}
